import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc062a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goals-page" }
const _hoisted_2 = { class: "goals-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "goals-eyebrow" }, "Seus planos, passo a passo"),
  /*#__PURE__*/_createElementVNode("h1", null, "Metas")
], -1))
const _hoisted_4 = { class: "goals-header__actions" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "goals-limit__word" }, "de", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "goals-limit__slash",
  "aria-hidden": "true"
}, "/", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "goal-tabs",
  "aria-label": "Área de metas"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Privadas", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "goal-tabs",
  role: "tablist",
  "aria-label": "Filtrar metas"
}
const _hoisted_15 = ["aria-selected"]
const _hoisted_16 = ["aria-selected"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["aria-selected"]
const _hoisted_19 = {
  key: 2,
  class: "goals-feedback goals-feedback--error",
  role: "alert"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = {
  key: 3,
  class: "goals-loading",
  "aria-label": "Carregando metas",
  role: "status"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal-skeleton goal-skeleton--hero" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal-skeleton" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal-skeleton" }, null, -1))
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "featured-goal__main" }
const _hoisted_27 = { class: "featured-goal__topline" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-sparkle",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Próxima conquista")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-calendar-blank",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_30 = { id: "featured-goal-title" }
const _hoisted_31 = { class: "featured-goal__amounts" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Você já guardou", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Valor da meta", -1))
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = { class: "featured-goal__progress-label" }
const _hoisted_36 = { class: "featured-goal__path" }
const _hoisted_37 = { class: "path-title" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-path",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Seu caminho", -1))
const _hoisted_40 = { class: "path-metrics" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por mês", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por dia", -1))
const _hoisted_43 = {
  key: 1,
  class: "path-warning"
}
const _hoisted_44 = { class: "featured-goal__actions" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-piggy-bank",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_46 = {
  class: "goals-overview",
  "aria-label": "Resumo das metas"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-wallet",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Total guardado", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-flag-checkered",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Falta conquistar", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-target",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Espaço disponível", -1))
const _hoisted_53 = ["aria-labelledby"]
const _hoisted_54 = { class: "section-heading" }
const _hoisted_55 = { class: "goals-eyebrow" }
const _hoisted_56 = ["id"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 0,
  class: "goal-card-grid"
}
const _hoisted_59 = { class: "goal-card__icon" }
const _hoisted_60 = ["aria-label", "onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-dots-three",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "goal-card__money" }
const _hoisted_64 = { class: "goal-progress" }
const _hoisted_65 = { class: "goal-card__progress" }
const _hoisted_66 = {
  key: 0,
  class: "goal-card__metrics"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por mês", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por dia", -1))
const _hoisted_69 = {
  key: 1,
  class: "goal-card__completed-date"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_71 = { class: "goal-card__actions" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_74 = ["onClick"]
const _hoisted_75 = {
  key: 2,
  class: "goals-pagination"
}
const _hoisted_76 = ["disabled"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = ["disabled"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = {
  key: 5,
  class: "empty-goals"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_84 = {
  key: 6,
  class: "goal-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "goal-form-title"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "goal-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_86 = { class: "goal-modal__header" }
const _hoisted_87 = { class: "goals-eyebrow" }
const _hoisted_88 = { id: "goal-form-title" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "goal-field" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome da meta", -1))
const _hoisted_93 = { class: "goal-form__row" }
const _hoisted_94 = { class: "goal-field goal-money-field" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor que você precisa", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "R$", -1))
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "goal-field" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data da conquista", -1))
const _hoisted_100 = ["min"]
const _hoisted_101 = {
  key: 0,
  class: "goal-field goal-money-field"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Quanto você já tem? "),
  /*#__PURE__*/_createElementVNode("small", null, "Opcional")
], -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "R$", -1))
const _hoisted_104 = ["value"]
const _hoisted_105 = {
  key: 1,
  class: "goal-preview",
  "aria-label": "Prévia do planejamento"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "ph ph-magic-wand",
      "aria-hidden": "true"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("small", null, "Prévia do seu caminho"),
    /*#__PURE__*/_createElementVNode("strong", null, "Você consegue chegar lá")
  ])
], -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Por mês", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Por dia", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tempo", -1))
const _hoisted_110 = {
  key: 2,
  class: "goals-feedback goals-feedback--error",
  role: "alert"
}
const _hoisted_111 = ["disabled"]
const _hoisted_112 = {
  key: 7,
  class: "goal-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "contribution-title"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "goal-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_114 = { class: "goal-modal__header" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "goals-eyebrow" }, "Movimentar reserva", -1))
const _hoisted_116 = { id: "contribution-title" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = {
  class: "contribution-switch",
  role: "radiogroup",
  "aria-label": "Tipo de movimentação"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-piggy-bank",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-bend-up-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_122 = { class: "available-value" }
const _hoisted_123 = { class: "goal-field goal-money-field contribution-amount" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "R$", -1))
const _hoisted_126 = ["value"]
const _hoisted_127 = { class: "goal-form__row" }
const _hoisted_128 = { class: "goal-field" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data", -1))
const _hoisted_130 = ["max"]
const _hoisted_131 = { class: "goal-field" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Observação "),
  /*#__PURE__*/_createElementVNode("small", null, "Opcional")
], -1))
const _hoisted_133 = {
  key: 0,
  class: "goals-feedback goals-feedback--error",
  role: "alert"
}
const _hoisted_134 = ["disabled"]
const _hoisted_135 = {
  key: 8,
  class: "goal-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "goal-detail-title"
}
const _hoisted_136 = { class: "goal-modal__content goal-detail" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "goal-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_138 = { class: "goal-modal__header" }
const _hoisted_139 = { class: "goals-eyebrow" }
const _hoisted_140 = { id: "goal-detail-title" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = {
  key: 0,
  class: "detail-loading"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-spinner-gap is-spinning",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_145 = { class: "detail-progress-card" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Progresso", -1))
const _hoisted_147 = { class: "goal-progress" }
const _hoisted_148 = { class: "detail-metrics" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Falta guardar", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Prazo", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por mês", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Por dia", -1))
const _hoisted_153 = {
  key: 0,
  class: "detail-actions"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-piggy-bank",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-pencil-simple",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_157 = ["disabled"]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-counter-clockwise",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-trash",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_160 = {
  key: 1,
  class: "goals-feedback goals-feedback--error detail-feedback",
  role: "alert"
}
const _hoisted_161 = {
  key: 2,
  class: "contribution-history"
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Alterações da meta", -1))
const _hoisted_163 = { class: "contribution-history" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "goals-eyebrow" }, "Movimentações"),
  /*#__PURE__*/_createElementVNode("h3", null, "Histórico de aportes")
], -1))
const _hoisted_165 = { key: 0 }
const _hoisted_166 = ["onClick"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-trash",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_168 = [
  _hoisted_167
]
const _hoisted_169 = { key: 1 }
const _hoisted_170 = {
  key: 9,
  class: "goal-confirm",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "confirm-action-title"
}
const _hoisted_171 = { id: "confirm-action-title" }
const _hoisted_172 = ["disabled"]
const _hoisted_173 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinancialPrivacyButton = _resolveComponent("FinancialPrivacyButton")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "goals-limit",
          "aria-label": `${_ctx.activeCount} de ${_ctx.activeLimit} metas utilizadas`
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.activeCount), 1),
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.activeLimit), 1)
        ], 8, _hoisted_5),
        _createVNode(_component_FinancialPrivacyButton),
        _createElementVNode("button", {
          class: "icon-button",
          type: "button",
          disabled: _ctx.getFinancialGoalsLoading,
          "aria-label": "Atualizar metas",
          title: "Atualizar metas",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadGoals && _ctx.loadGoals(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.getFinancialGoalsLoading }]),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_8),
        _createElementVNode("button", {
          class: "new-goal-button",
          type: "button",
          disabled: !_ctx.canCreateGoal,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
        }, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(_ctx.canCreateGoal ? 'Nova meta' : 'Limite atingido'), 1)
        ], 8, _hoisted_9)
      ])
    ]),
    (_ctx.$store.getters.getCouple)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({active: _ctx.$store.getters.getGoalsScope === 'self'}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.dispatch('selectGoalsScope', 'self')))
          }, [
            _createTextVNode("Minhas metas "),
            _hoisted_12
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({active: _ctx.$store.getters.getGoalsScope === 'couple'}),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$store.dispatch('selectGoalsScope', 'couple')))
          }, "Metas do casal", 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.getters.getGoalsScope === 'couple')
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Os dois podem ajustar a meta. Cada um movimenta apenas sua própria participação."))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass({ active: _ctx.activeTab === 'active' }),
        "aria-selected": _ctx.activeTab === 'active',
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTab('active')))
      }, [
        _createTextVNode(" Em andamento "),
        _createElementVNode("span", null, _toDisplayString(_ctx.activeCount), 1)
      ], 10, _hoisted_15),
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass({ active: _ctx.activeTab === 'completed' }),
        "aria-selected": _ctx.activeTab === 'completed',
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeTab('completed')))
      }, [
        _createTextVNode(" Concluídas "),
        (_ctx.activeTab === 'completed')
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.getFinancialGoalsPagination.total), 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_16),
      (_ctx.$store.getters.getGoalsScope === 'self')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            role: "tab",
            class: _normalizeClass({active: _ctx.activeTab === 'archived'}),
            "aria-selected": _ctx.activeTab === 'archived',
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeTab('archived')))
          }, "Arquivadas", 10, _hoisted_18))
        : _createCommentVNode("", true)
    ]),
    (_ctx.getFinancialGoalsError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("span", null, [
            _hoisted_20,
            _createTextVNode(_toDisplayString(_ctx.getFinancialGoalsError), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.loadGoals && _ctx.loadGoals(...args)))
          }, "Tentar novamente")
        ]))
      : _createCommentVNode("", true),
    (_ctx.getFinancialGoalsLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_21, _hoisted_25))
      : (_ctx.getFinancialGoals.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (_ctx.activeTab === 'active' && _ctx.featuredGoal)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("section", {
                    class: _normalizeClass(["featured-goal", { 'is-overdue': _ctx.featuredGoal.metrics.is_overdue }]),
                    "aria-labelledby": "featured-goal-title"
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", {
                          class: _normalizeClass(["deadline-pill", { 'is-overdue': _ctx.featuredGoal.metrics.is_overdue }])
                        }, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(_ctx.featuredDeadlineLabel), 1)
                        ], 2)
                      ]),
                      _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.featuredGoal.title), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _hoisted_32,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.featuredGoal.metrics.saved_amount.formatted)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_33,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.featuredGoal.target_amount.formatted)), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "goal-progress",
                        "aria-label": `${_ctx.featuredGoal.metrics.progress_percentage}% concluído`
                      }, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ width: `${_ctx.featuredGoal.metrics.progress_percentage}%` })
                        }, null, 4)
                      ], 8, _hoisted_34),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.featuredGoal.metrics.progress_percentage) + "%", 1),
                        _createElementVNode("span", null, "Faltam " + _toDisplayString(_ctx.privateValue(_ctx.featuredGoal.metrics.remaining_amount.formatted)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", null, [
                          _hoisted_39,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.featuredGoal.metrics.is_overdue ? 'Revise o prazo' : 'Um pouco por vez'), 1)
                        ])
                      ]),
                      (!_ctx.featuredGoal.metrics.is_overdue && _ctx.featuredGoal.metrics.daily_required)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", null, [
                                _hoisted_41,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.featuredGoal.metrics.monthly_required.formatted)), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_42,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.featuredGoal.metrics.daily_required.formatted)), 1)
                              ])
                            ]),
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.featuredGoal.metrics.days_remaining) + " dias", 1),
                              _createTextVNode(" · cerca de " + _toDisplayString(_ctx.monthsLabel(_ctx.featuredGoal.metrics.months_remaining)), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("p", _hoisted_43, "A data planejada passou. Escolha um novo prazo para recalcular seu caminho.")),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "primary",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openContributionModal(_ctx.featuredGoal)))
                        }, [
                          _hoisted_45,
                          _createTextVNode(" Guardar dinheiro")
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openDetails(_ctx.featuredGoal)))
                        }, "Ver detalhes")
                      ])
                    ])
                  ], 2),
                  _createElementVNode("section", _hoisted_46, [
                    _createElementVNode("article", null, [
                      _hoisted_47,
                      _createElementVNode("div", null, [
                        _hoisted_48,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.getFinancialGoalsSummary.total_saved.formatted)), 1)
                      ])
                    ]),
                    _createElementVNode("article", null, [
                      _hoisted_49,
                      _createElementVNode("div", null, [
                        _hoisted_50,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.getFinancialGoalsSummary.total_remaining.formatted)), 1)
                      ])
                    ]),
                    _createElementVNode("article", null, [
                      _hoisted_51,
                      _createElementVNode("div", null, [
                        _hoisted_52,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.slotsRemaining) + " " + _toDisplayString(_ctx.slotsRemaining === 1 ? 'nova meta' : 'novas metas'), 1)
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'completed' || _ctx.remainingGoals.length)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: "goals-list-section",
                  "aria-labelledby": _ctx.activeTab === 'active' ? 'other-goals-title' : 'completed-goals-title'
                }, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.activeTab === 'active' ? 'Continue avançando' : 'Seu histórico'), 1),
                      _createElementVNode("h2", {
                        id: _ctx.activeTab === 'active' ? 'other-goals-title' : 'completed-goals-title'
                      }, _toDisplayString(_ctx.activeTab === 'active' ? (_ctx.remainingGoals.length ? 'Outras metas' : 'Sua meta em foco') : 'Conquistas concluídas'), 9, _hoisted_56)
                    ]),
                    (_ctx.activeTab === 'active')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Cada aporte deixa o objetivo mais perto."))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.visibleGoalCards.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGoalCards, (goal) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: goal.id,
                            class: _normalizeClass(["goal-card", { 'is-completed': goal.status === 'completed', 'is-overdue': goal.metrics.is_overdue }])
                          }, [
                            _createElementVNode("header", null, [
                              _createElementVNode("span", _hoisted_59, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(goal.status === 'completed' ? 'ph ph-trophy' : 'ph ph-target'),
                                  "aria-hidden": "true"
                                }, null, 2)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("small", null, _toDisplayString(goal.status === 'completed' ? 'Meta conquistada' : _ctx.deadlineLabel(goal)), 1),
                                _createElementVNode("h3", null, _toDisplayString(goal.title), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                "aria-label": `Ver detalhes de ${goal.title}`,
                                onClick: ($event: any) => (_ctx.openDetails(goal))
                              }, _hoisted_62, 8, _hoisted_60)
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(goal.metrics.saved_amount.formatted)), 1),
                              _createElementVNode("span", null, "de " + _toDisplayString(_ctx.privateValue(goal.target_amount.formatted)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ width: `${goal.metrics.progress_percentage}%` })
                              }, null, 4)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("span", null, _toDisplayString(goal.metrics.progress_percentage) + "% concluído", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(goal.metrics.remaining_amount.formatted)) + " restantes", 1)
                            ]),
                            (goal.status === 'active')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("small", null, _toDisplayString(goal.metrics.is_overdue ? 'Prazo' : 'Tempo'), 1),
                                    _createElementVNode("strong", null, _toDisplayString(goal.metrics.is_overdue ? 'Vencido' : goal.metrics.duration_label), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_67,
                                    _createElementVNode("strong", null, _toDisplayString(goal.metrics.monthly_required ? _ctx.privateValue(goal.metrics.monthly_required.formatted) : 'Recalcular'), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_68,
                                    _createElementVNode("strong", null, _toDisplayString(goal.metrics.daily_required ? _ctx.privateValue(goal.metrics.daily_required.formatted) : 'Recalcular'), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                  _hoisted_70,
                                  _createTextVNode(" Concluída em " + _toDisplayString(_ctx.formatDateTime(goal.completed_at)), 1)
                                ])),
                            _createElementVNode("div", _hoisted_71, [
                              (goal.status === 'active')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "primary",
                                    onClick: ($event: any) => (_ctx.openContributionModal(goal))
                                  }, [
                                    _hoisted_73,
                                    _createTextVNode(" Fazer aporte")
                                  ], 8, _hoisted_72))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.openDetails(goal))
                              }, "Detalhes", 8, _hoisted_74)
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_53))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'completed' && _ctx.getFinancialGoalsPagination.last_page > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage <= 1,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                  }, _hoisted_78, 8, _hoisted_76),
                  _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getFinancialGoalsPagination.last_page), 1),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage >= _ctx.getFinancialGoalsPagination.last_page,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                  }, _hoisted_81, 8, _hoisted_79)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (!_ctx.getFinancialGoalsError)
          ? (_openBlock(), _createElementBlock("section", _hoisted_82, [
              _createElementVNode("span", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.activeTab === 'active' ? 'ph ph-flag-banner' : 'ph ph-trophy'),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _createElementVNode("h2", null, _toDisplayString(_ctx.activeTab === 'active' ? 'Qual é o seu próximo sonho?' : 'Suas conquistas aparecerão aqui'), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.activeTab === 'active' ? 'Crie uma meta e veja um caminho simples para transformar seu plano em realidade.' : 'Quando uma meta for concluída, ela ficará guardada neste histórico.'), 1),
              (_ctx.activeTab === 'active')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
                  }, [
                    _hoisted_83,
                    _createTextVNode(" Criar minha primeira meta")
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeTab('active')))
                  }, "Ver metas em andamento"))
            ]))
          : _createCommentVNode("", true),
    (_ctx.showGoalForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
          _createElementVNode("div", {
            class: "goal-modal__backdrop",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeGoalForm && _ctx.closeGoalForm(...args)))
          }),
          _createElementVNode("form", {
            class: "goal-modal__content goal-form",
            onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitGoal && _ctx.submitGoal(...args)), ["prevent"]))
          }, [
            _hoisted_85,
            _createElementVNode("header", _hoisted_86, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.editingGoalId ? 'Ajustar planejamento' : 'Nova conquista'), 1),
                _createElementVNode("h2", _hoisted_88, _toDisplayString(_ctx.editingGoalId ? 'Editar meta' : 'O que você quer conquistar?'), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeGoalForm && _ctx.closeGoalForm(...args)))
              }, _hoisted_90)
            ]),
            _createElementVNode("label", _hoisted_91, [
              _hoisted_92,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.goalForm.title) = $event)),
                type: "text",
                maxlength: "120",
                required: "",
                placeholder: "Ex: viagem, carro, casa nova"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.goalForm.title,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("label", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", null, [
                  _hoisted_96,
                  _createElementVNode("input", {
                    value: _ctx.targetAmountInput,
                    inputmode: "numeric",
                    required: "",
                    placeholder: "0,00",
                    onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onMoneyInput($event, 'targetAmountInput')))
                  }, null, 40, _hoisted_97)
                ])
              ]),
              _createElementVNode("label", _hoisted_98, [
                _hoisted_99,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.goalForm.target_date) = $event)),
                  type: "date",
                  min: _ctx.minimumTargetDate,
                  required: ""
                }, null, 8, _hoisted_100), [
                  [_vModelText, _ctx.goalForm.target_date]
                ])
              ])
            ]),
            (!_ctx.editingGoalId)
              ? (_openBlock(), _createElementBlock("label", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", null, [
                    _hoisted_103,
                    _createElementVNode("input", {
                      value: _ctx.initialAmountInput,
                      inputmode: "numeric",
                      placeholder: "0,00",
                      onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onMoneyInput($event, 'initialAmountInput')))
                    }, null, 40, _hoisted_104)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.goalPreview)
              ? (_openBlock(), _createElementBlock("section", _hoisted_105, [
                  _hoisted_106,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_107,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.goalPreview.monthly))), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_108,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.goalPreview.daily))), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_109,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.goalPreview.days) + " dias", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formFeedback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_ctx.formFeedback), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "save-goal-button",
              type: "submit",
              disabled: _ctx.saving
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Salvando...' : _ctx.editingGoalId ? 'Salvar alterações' : 'Criar minha meta'), 1),
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.saving ? 'ph ph-spinner-gap is-spinning' : 'ph ph-arrow-right'),
                "aria-hidden": "true"
              }, null, 2)
            ], 8, _hoisted_111)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.contributionGoal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
          _createElementVNode("div", {
            class: "goal-modal__backdrop",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeContributionModal && _ctx.closeContributionModal(...args)))
          }),
          _createElementVNode("form", {
            class: "goal-modal__content contribution-form",
            onSubmit: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitContribution && _ctx.submitContribution(...args)), ["prevent"]))
          }, [
            _hoisted_113,
            _createElementVNode("header", _hoisted_114, [
              _createElementVNode("div", null, [
                _hoisted_115,
                _createElementVNode("h2", _hoisted_116, _toDisplayString(_ctx.contributionGoal.title), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.closeContributionModal && _ctx.closeContributionModal(...args)))
              }, _hoisted_118)
            ]),
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ active: _ctx.contributionForm.type === 'deposit' }),
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.contributionForm.type = 'deposit'))
              }, [
                _hoisted_120,
                _createTextVNode(" Guardar")
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ active: _ctx.contributionForm.type === 'withdrawal' }),
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.contributionForm.type = 'withdrawal'))
              }, [
                _hoisted_121,
                _createTextVNode(" Retirar")
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("span", null, _toDisplayString(_ctx.contributionForm.type === 'deposit' ? 'Falta para a meta' : 'Disponível para retirar'), 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.contributionForm.type === 'deposit' ? _ctx.contributionGoal.metrics.remaining_amount.formatted : _ctx.contributionGoal.metrics.saved_amount.formatted)), 1)
            ]),
            _createElementVNode("label", _hoisted_123, [
              _hoisted_124,
              _createElementVNode("div", null, [
                _hoisted_125,
                _createElementVNode("input", {
                  value: _ctx.contributionAmountInput,
                  inputmode: "numeric",
                  required: "",
                  autofocus: "",
                  placeholder: "0,00",
                  onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onMoneyInput($event, 'contributionAmountInput')))
                }, null, 40, _hoisted_126)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("label", _hoisted_128, [
                _hoisted_129,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.contributionForm.occurred_on) = $event)),
                  type: "date",
                  max: _ctx.todayInput,
                  required: ""
                }, null, 8, _hoisted_130), [
                  [_vModelText, _ctx.contributionForm.occurred_on]
                ])
              ]),
              _createElementVNode("label", _hoisted_131, [
                _hoisted_132,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.contributionForm.note) = $event)),
                  type: "text",
                  maxlength: "240",
                  placeholder: "Ex: dinheiro extra"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.contributionForm.note,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            (_ctx.formFeedback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, _toDisplayString(_ctx.formFeedback), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "save-goal-button",
              type: "submit",
              disabled: _ctx.saving
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Salvando...' : _ctx.contributionForm.type === 'deposit' ? 'Guardar este valor' : 'Confirmar retirada'), 1),
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.saving ? 'ph ph-spinner-gap is-spinning' : 'ph ph-check'),
                "aria-hidden": "true"
              }, null, 2)
            ], 8, _hoisted_134)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedGoal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
          _createElementVNode("div", {
            class: "goal-modal__backdrop",
            onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_136, [
            _hoisted_137,
            _createElementVNode("header", _hoisted_138, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.selectedGoal.status === 'completed' ? 'Conquista' : 'Detalhes da meta'), 1),
                _createElementVNode("h2", _hoisted_140, _toDisplayString(_ctx.selectedGoal.title), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
              }, _hoisted_142)
            ]),
            (_ctx.detailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                  _hoisted_144,
                  _createTextVNode(" Carregando detalhes...")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_145, [
                    _createElementVNode("div", null, [
                      _hoisted_146,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedGoal.metrics.progress_percentage) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ width: `${_ctx.selectedGoal.metrics.progress_percentage}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(_ctx.selectedGoal.metrics.saved_amount.formatted)), 1),
                      _createTextVNode(" guardados de " + _toDisplayString(_ctx.privateValue(_ctx.selectedGoal.target_amount.formatted)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_148, [
                    _createElementVNode("article", null, [
                      _hoisted_149,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.selectedGoal.metrics.remaining_amount.formatted)), 1)
                    ]),
                    _createElementVNode("article", null, [
                      _hoisted_150,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.selectedGoal.target_date)), 1)
                    ]),
                    _createElementVNode("article", null, [
                      _hoisted_151,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedGoal.metrics.monthly_required ? _ctx.privateValue(_ctx.selectedGoal.metrics.monthly_required.formatted) : '—'), 1)
                    ]),
                    _createElementVNode("article", null, [
                      _hoisted_152,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedGoal.metrics.daily_required ? _ctx.privateValue(_ctx.selectedGoal.metrics.daily_required.formatted) : '—'), 1)
                    ])
                  ]),
                  (_ctx.selectedGoal.can_edit !== false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                        (_ctx.selectedGoal.status === 'active')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "primary",
                              type: "button",
                              onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.openContributionFromDetails && _ctx.openContributionFromDetails(...args)))
                            }, [
                              _hoisted_154,
                              _createTextVNode(" Fazer aporte")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedGoal.status === 'active')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.openEditFromDetails && _ctx.openEditFromDetails(...args)))
                            }, [
                              _hoisted_155,
                              _createTextVNode(" Editar")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedGoal.status === 'active')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.requestAction('complete', _ctx.selectedGoal)))
                            }, [
                              _hoisted_156,
                              _createTextVNode(" Concluir")
                            ]))
                          : (_ctx.selectedGoal.completion_type === 'manual' && _ctx.selectedGoal.metrics.remaining_amount.raw > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                disabled: _ctx.actionLoading,
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.reopenGoal(_ctx.selectedGoal)))
                              }, [
                                _hoisted_158,
                                _createTextVNode(" Reabrir")
                              ], 8, _hoisted_157))
                            : _createCommentVNode("", true),
                        (!_ctx.selectedGoal.couple_id)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              class: "danger",
                              type: "button",
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.requestAction('delete', _ctx.selectedGoal)))
                            }, [
                              _hoisted_159,
                              _createTextVNode(" Excluir")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.actionFeedback)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(_ctx.actionFeedback), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedGoal.changes?.length)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_161, [
                        _hoisted_162,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGoal.changes, (change) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: change.id
                          }, _toDisplayString(_ctx.formatDate(change.created_at)) + " · " + _toDisplayString(change.author_name) + " · " + _toDisplayString(_ctx.changeLabel(change.changes)), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_163, [
                    _createElementVNode("header", null, [
                      _hoisted_164,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedGoal.contributions?.length || 0), 1)
                    ]),
                    (_ctx.selectedGoal.contributions?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGoal.contributions, (item) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: item.id
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(item.type)
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(item.type === 'deposit' ? 'ph ph-arrow-down-left' : 'ph ph-arrow-up-right'),
                                  "aria-hidden": "true"
                                }, null, 2)
                              ], 2),
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(item.note || (item.type === 'deposit' ? 'Valor guardado' : 'Retirada')), 1),
                                _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(item.occurred_on)) + " · " + _toDisplayString(item.owner_name), 1)
                              ]),
                              _createElementVNode("b", {
                                class: _normalizeClass(item.type)
                              }, _toDisplayString(_ctx.privateValue(`${item.type === 'deposit' ? '+' : '−'} ${item.amount.formatted}`)), 3),
                              (item.can_delete !== false)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    "aria-label": 'Excluir movimentação',
                                    onClick: ($event: any) => (_ctx.requestAction('deleteContribution', _ctx.selectedGoal, item))
                                  }, _hoisted_168, 8, _hoisted_166))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_169, "Nenhum aporte registrado ainda."))
                  ])
                ], 64))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pendingAction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
          _createElementVNode("div", {
            class: "goal-modal__backdrop",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.pendingAction = null))
          }),
          _createElementVNode("section", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ danger: _ctx.pendingAction.type !== 'complete' })
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.pendingAction.type === 'complete' ? 'ph ph-trophy' : 'ph ph-warning'),
                "aria-hidden": "true"
              }, null, 2)
            ], 2),
            _createElementVNode("h2", _hoisted_171, _toDisplayString(_ctx.confirmationTitle), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.confirmationText), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.actionLoading,
                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.pendingAction = null))
              }, "Cancelar", 8, _hoisted_172),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ danger: _ctx.pendingAction.type !== 'complete' }),
                disabled: _ctx.actionLoading,
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.runPendingAction && _ctx.runPendingAction(...args)))
              }, _toDisplayString(_ctx.actionLoading ? 'Aguarde...' : _ctx.confirmationButton), 11, _hoisted_173)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}